export enum BizTargetType {
  DEALER = 'DEALER',
  DIRECT_PARTNER = 'DIRECT_PARTNER',
  INDIRECT_PARTNER = 'INDIRECT_PARTNER'
}

export const BIZ_TARGET_TYPE = {
  [BizTargetType.DEALER]: '딜러사',
  [BizTargetType.DIRECT_PARTNER]: '직계약',
  [BizTargetType.INDIRECT_PARTNER]: '간접계약'
} as const;

export const BIZ_TARGET_TIARA_TYPE = {
  [BizTargetType.DEALER]: '딜러사',
  [BizTargetType.DIRECT_PARTNER]: '직접이용기관',
  [BizTargetType.INDIRECT_PARTNER]: '간접이용기관'
} as const;

export const ALL_TYPES = Object.values(BizTargetType);
export const DEALER_TYPE = [BizTargetType.DEALER];
export const DIRECT_PARTNER_TYPE = [BizTargetType.DIRECT_PARTNER];
export const PARTNER_TYPES = [BizTargetType.DIRECT_PARTNER, BizTargetType.INDIRECT_PARTNER];
export const SETTLEABLE_TYPES = [BizTargetType.DEALER, BizTargetType.DIRECT_PARTNER];
export const CONTRACT_ADDABLE_TYPES = [BizTargetType.DEALER, BizTargetType.DIRECT_PARTNER];
